"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSelectPaginationByListType = exports.selectIsPollingTurnedOffConsideringTablets = exports.selectIsPollingTurnedOff = exports.selectIsPaginationEnabled = exports.selectDirection = exports.selectIsInitialLoad = exports.selectIsVeryTopVisible = exports.selectPaginationByLocation = exports.selectPagination = exports.selectMatchListTypeFromProps = void 0;
var reselect_1 = require("reselect");
var core_1 = __importDefault(require("@gin-betting/core"));
var getRouteFromPathname = core_1.default.utils.getRouteFromPathname, selectLocationFromProps = core_1.default.entities.selectors.selectLocationFromProps, selectIsTablet = core_1.default.viewport.selectors.selectIsTablet;
var selectMatchListTypeFromProps = function (_, props) {
    return props.pollerName;
};
exports.selectMatchListTypeFromProps = selectMatchListTypeFromProps;
var selectPagination = function (state) {
    return state.get('pagination');
};
exports.selectPagination = selectPagination;
exports.selectPaginationByLocation = reselect_1.createSelector(selectLocationFromProps, exports.selectPagination, function (_a, pagination) {
    var pathname = _a.pathname;
    var categoryName = getRouteFromPathname(pathname);
    var category = pagination[categoryName];
    if (process.env.NODE_ENV === 'development' && !category)
        throw Error("[Pagination] Not defined match list by category: " + categoryName);
    return category;
});
exports.selectIsVeryTopVisible = reselect_1.createSelector(exports.selectPagination, function (pagination) { return pagination.isVeryTopVisible; });
/* common */
exports.selectIsInitialLoad = reselect_1.createSelector(exports.selectPagination, function (pagination) { return pagination.initialLoad; });
exports.selectDirection = reselect_1.createSelector(exports.selectPagination, function (pagination) { return pagination.direction; });
exports.selectIsPaginationEnabled = reselect_1.createSelector(exports.selectPagination, function (pagination) { return pagination.enabled; });
exports.selectIsPollingTurnedOff = reselect_1.createSelector(exports.selectPagination, function (pagination) { return pagination.isPollingTurnedOff; });
exports.selectIsPollingTurnedOffConsideringTablets = reselect_1.createSelector(exports.selectIsPollingTurnedOff, selectIsTablet, function (isPollingTurnedOff, isTablet) {
    /* 'cause of sticky categorizer for tablets
    polling should be enabled for those cases */
    return isPollingTurnedOff && !isTablet;
});
function makeSelectPaginationByListType(listType) {
    return reselect_1.createSelector(exports.selectPagination, function (pagination) {
        return pagination.get(listType);
    });
}
exports.makeSelectPaginationByListType = makeSelectPaginationByListType;
//# sourceMappingURL=selectors.js.map